import { render, staticRenderFns } from "./GrantsList.vue?vue&type=template&id=54dbebc4&scoped=true"
import script from "./GrantsList.vue?vue&type=script&lang=js"
export * from "./GrantsList.vue?vue&type=script&lang=js"
import style0 from "./GrantsList.vue?vue&type=style&index=0&id=54dbebc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dbebc4",
  null
  
)

export default component.exports